import React, { forwardRef } from "react";
import styled, { css } from "styled-components";

const ButtonBase = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  min-height: 44px;
  max-width: 100%;
  padding: 16px 24px;
  border-radius: 99px;
  border: 1px solid #fff9dc;
  font: 700 clamp(14px, 1.4vw, 22px)/1.25 Arial, sans-serif;
  letter-spacing: .08em;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  overflow-wrap: anywhere;
  color: #481b05;
  background:
    radial-gradient(ellipse at 50% 0, #ffffff73, transparent 70%),
    linear-gradient(180deg, #fff8d7, #f6d675 40%, #dcaa38 65%, #f4ce6e);
  box-shadow:
    inset 0 1px 2px #fffef2,
    0 0 4px #fff0b2,
    0 0 13px #ffd35ea6,
    0 0 26px #ffb51d5c,
    0 4px 0 #9f671d;
  text-shadow: 0 1px #ffe4a0;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  transition: filter .2s, transform .2s;
  ${({ $variant }) => $variant === "outline" && css`
    color: #ffeac2;
    background: #290406a8;
    border-color: #c09352;
    box-shadow: inset 0 1px 0 #efc68830;
    text-shadow: none;
  `}
  &:hover:not(:disabled):not([aria-disabled="true"]) { filter: brightness(1.12); transform: translateY(-2px); }
  &:active:not(:disabled):not([aria-disabled="true"]) { transform: translateY(1px); }
  &:focus-visible { outline: 3px solid #fff4c5; outline-offset: 4px; }
  &:disabled, &[aria-disabled="true"] { opacity: .5; cursor: not-allowed; filter: saturate(.35); transform: none; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;

// Keep legacy primary/secondary callers and styled(Button) wrappers compatible.
const Button = forwardRef(function Button({ children, variant = "solid", type = "button", ...props }, ref) {
  const appearance = variant === "outline" || variant === "secondary" ? "outline" : "solid";
  return <ButtonBase ref={ref} type={type} $variant={appearance} data-button-variant={appearance} {...props}>{children}</ButtonBase>;
});

export default Button;
